<p>
  {{ 'CHOOSE_PASSPHRASE_DESCRIPTION' | translate }}
</p>

<form [formGroup]="passphraseForm">
  <vaadin-radio-group
    id="choose-passphrase"
    theme="vertical"
    required
    formControlName="preference"
    ngDefaultControl>
      <vaadin-radio-button theme="eobi" value="default" checked>{{ 'CHOOSE_PASSPHRASE_PREFERENCE_USE_DEFAULT' | translate }}</vaadin-radio-button>
      <vaadin-radio-button theme="eobi" value="custom">{{ 'CHOOSE_PASSPHRASE_PREFERENCE_USE_CUSTOM' | translate }}</vaadin-radio-button>
  </vaadin-radio-group>
  <div class="custom-passphrase" [formGroup]="passphraseGroup" *ngIf="!useDefaultValue">
    <vaadin-password-field
      theme="eobi"
      id="passphrase"
      label="{{ 'CHOOSE_PASSPHRASE_PASSPHRASE_PLACEHOLDER' | translate }}"
      [checkValidity]="passphraseValidator()"
      [errorMessage]="getCurrentPassphraseErrorMessage()"
      formControlName="passphrase"
      ngDefaultControl>
        <span slot="helper">{{ 'CHOOSE_PASSPHRASE_PASSPHRASE_HELPER' | translate }}</span>
    </vaadin-password-field>
    <vaadin-password-field
      theme="eobi"
      id="confirm-passphrase"
      label="{{ 'CHOOSE_PASSPHRASE_CONFIRM_PASSPHRASE_PLACEHOLDER' | translate }}"
      [checkValidity]="repeatPassphraseValidator()"
      [errorMessage]="getRepeatCurrentPassphraseErrorMessage()"
      formControlName="repeat"
      ngDefaultControl>
    </vaadin-password-field>
  </div>
</form>



